import { render, staticRenderFns } from "./CreateNewSalaryStructure.vue?vue&type=template&id=668b3150&scoped=true"
import script from "./CreateNewSalaryStructure.vue?vue&type=script&lang=js"
export * from "./CreateNewSalaryStructure.vue?vue&type=script&lang=js"
import style0 from "./CreateNewSalaryStructure.vue?vue&type=style&index=0&id=668b3150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668b3150",
  null
  
)

export default component.exports